<template>
  <div class="messages">
    <box :title="$t('messages-list')" v-if="messages.length > 0">
      <div>
        <v-data-table
          dense
          :disable-sort="true"
          :headers="headers"
          hide-default-footer
          disable-pagination
          :items="messages"
          item-key="MessageId"
          group-by="Sender"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th class="group-header" :colspan="headers.length">
              <div>
                 <!-- <v-icon @click="seen(isOpen,toggle)"  -->
                <v-icon @click="toggle"  
                  >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
                {{ items[0].Sender }}
              </div>
            </th>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <strong v-if="item.ReadDate == ''">{{ item.Subject }}</strong>
                <span v-else>{{ item.Subject }}</span>
              </td>
              <td>{{ item.SentDate }}</td>
              <td>{{ item.ReadDate }}</td>
              <td @click="showMessage(item)">
                <v-btn text>{{ $t("show") }}</v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </box>
    <eos-dialog ref="dialog" />
  </div>
</template>

<script>
import ArrayUtils from "../../utils/ArrayUtils";
import ResultType from "../../model/ResultType";
export default {
  data() {
    return {
      messages: [],
      groupMessages: [],
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: this.$t("Subject"),
          value: "Subject",
        },
        {
          text: this.$t("SentDate"),
          value: "SentDate",
        },
        {
          text: this.$t("ReadDate"),
          value: "ReadDate",
        },
        {
          text: "",
          value: "show",
        },
      ],
    };
  },
  mounted() {
    this.GetInbox();
  },
  methods: {
    GetInbox() {
      this.$store.dispatch("GetInbox").then((result) => {
        if (result.type === "success") {
          this.messages = result.data.Table;
          var obj = ArrayUtils.groupBy(this.messages, "Sender");
          var arr = [];
          Object.keys(obj).forEach((key) => {
            var item = { key: key, group: obj[key] };
            arr.push(item);
          });
          this.groupMessages = arr;
        }
      });
    },
    showMessage(item) {
      debugger
      this.$store.dispatch("MarkAsRead", item.MessageId).then((result) => {
        console.log(result);
        if (result.type == ResultType.success) {
          debugger
          this.$emit("refresh");
        }
      });

      this.$refs.dialog.show(this.$t("message"), item.Message);
      this.GetInbox();
    },
    seen(isOpen,toggle){
      debugger
      console.log(isOpen)
      console.log(toggle)

    },
  },
};
</script>

<style scoped>
.group-header {
  background: #ededed !important;
}
</style>